import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import api from "../../axiosConfig";

export default function TipFacturaIntrareCreate() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ tip_factura: "" });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm((f) => ({ ...f, [name]: checked }));
    } else if (type === "number") {
      setForm((f) => ({ ...f, [name]: value === "" ? "" : Number(value) }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const payload = { ...form };

      await api.post("/tip_factura_intrare", payload);
      navigate("/tip_factura_intrare");
    } catch (err) {
      alert("Eroare la creare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="mt-4">
      <Card className="p-3">
        <h3>Creare TipFacturaIesire</h3>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>tip_factura</Form.Label>
                <Form.Control
                  type="text"
                  name="tip_factura"
                  value={form.tip_factura ?? ""}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="text-end">
            <Button type="submit" disabled={submitting}>
              Salvează
            </Button>
          </div>
        </Form>
      </Card>
    </Container>
  );
}
